import { RHFAutoCompleteVirtualize } from '@openx/components-core/lib/AutoComplete/RHFAutoCompleteVirtualize.tsx';
import { useTranslation } from 'react-i18next';

import { DealParticipantsField } from '../fields.ts';

export interface ParticipantBuyersFreeFormProps {
  fieldPrefix: string;
}

export const ParticipantBuyersFreeForm = ({ fieldPrefix }: ParticipantBuyersFreeFormProps) => {
  const { t } = useTranslation();

  return (
    <RHFAutoCompleteVirtualize<string, true, false, true>
      name={`${fieldPrefix}${DealParticipantsField.BUYER_IDS}`}
      textFieldProps={{
        label: t('DSP Seat IDs'),
        margin: 'dense',
        placeholder: t('Type a Seat ID and press Enter'),
      }}
      options={[]}
      multiple
      freeSolo
      data-test="deal-dsp-seat-ids-freeform"
    />
  );
};
